// ShopMessage.jsx  (※ ProductScreen に直書きする場合も同じ)

import { useState, useRef, useLayoutEffect } from 'react';

const ShopMessage = ({ product }) => {
  const [expanded, setExpanded]  = useState(false);
  const [clamped,  setClamped]   = useState(false);   // ← はみ出し判定
  const detailRef = useRef(null);

  // ─── 高さを測定 ───────────────────────────────────────
  useLayoutEffect(() => {
    const checkClamp = () => {
      if (!detailRef.current) return;
      /* 「展開前の高さ」で比較したいので、いったん閉じた状態で測る */
      const wasExpanded = expanded;
      if (wasExpanded) detailRef.current.classList.remove('expanded');

      const needClamp =
        detailRef.current.scrollHeight >
        detailRef.current.clientHeight + 1; // +1 で誤差吸収

      setClamped(needClamp);

      if (wasExpanded) detailRef.current.classList.add('expanded');
    };

    checkClamp();               // 初回
    window.addEventListener('resize', checkClamp); // 画面幅が変わったら再計算
    return () => window.removeEventListener('resize', checkClamp);
  }, [expanded, product?.description]); // 商品が切り替わったら再測定

  if (!product) return null;

  return (
    <div className="shopmessage">
      <div className="shopmessage-tab">SHOP&nbsp;MESSAGE</div>

      <div
        ref={detailRef}
        className={`shopmessage-detail
                    ${expanded ? 'expanded' : ''}
                    ${clamped  ? 'clamped'  : ''}`}
        /* expanded かどうかで inline‑style を一切切り替えなくても
           SCSS だけで操作できるようにクラス名を付与 */
      >
        {product.description}
      </div>

      {/* はみ出したときだけトグルを表示 */}
      {clamped && (
        <div
          className="shopmessage-toggle"
          onClick={() => setExpanded((v) => !v)}
        >
          {expanded ? '閉じる' : 'MORE'}
        </div>
      )}
    </div>
  );
};

export default ShopMessage;
